module.exports = __webpack_public_path__ + "media/images/85/CBD_facts_woman_on_bed-332523692dfad0bdcadacb62dc152f5e.webp";